import {useDispatch, useSelector} from "react-redux";
import {makeStore} from "@/utils/storage/stores/makeStore.ts";
import type { ThunkDispatch, AnyAction } from "@reduxjs/toolkit";

export const store = makeStore();

// Определяем RootState на основе типов из makeStore
export interface RootState {
    user: ReturnType<typeof import("../persist/userPersistedReducer").userPersistedReducer> | ReturnType<typeof import("../slices/userSlice").default>;
    cart: ReturnType<typeof import("../persist/cartPersistedReducer").cartPersistedReducer> | ReturnType<typeof import("../slices/cartSlice").default>;
    laximo: ReturnType<typeof import("../slices/laximoSlice").default>;
}

export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
